export default {
  selectedWelcomeState: state => state.selectedWelcome
}
